export const Loadinggif = "/assets/gif/Loading.gif";
